import { IEventDetailTopic } from "../models";

export type TopicActivity = "itsCoaching" | "itsTraining" | "itbcCoaching" | "itbcTraining" | "itbcChildCoaching";

// Amy's October 1 list plus October 5 T-TS correction. Coaching also applies to TA.
export const EVENT_TOPIC_MATRIX: ReadonlyArray<IEventDetailTopic & { activities: TopicActivity[] }> = [
  {
    "displayName": "Inclusion",
    "entityName": "isDisaInclusion",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Infant Early Language Support",
    "entityName": "isEarlyLanguageSupport",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Infant Facilitated Exploration",
    "entityName": "isFacilitatedExploration",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Infant Relational Climate",
    "entityName": "isRelationalClimate",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Infant Teacher Sensitivity",
    "entityName": "isInfantTeacherSensitivity",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Program Management/Leadership",
    "entityName": "isProgramManagement",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Toddler Behavior Guidance",
    "entityName": "isBehaviorGuidance",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Toddler Facilitation of Learning & Development",
    "entityName": "isFacilitationOfLearningAndDevelopment",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Toddler Language Modeling",
    "entityName": "isLanguageModeling",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Toddler Negative Climate",
    "entityName": "isNegativeClimate",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Toddler Positive Climate",
    "entityName": "isPositiveClimate",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Toddler Quality of Feedback",
    "entityName": "isQualityOfFeedback",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Toddler Regard for Child Perspectives",
    "entityName": "isRegardForChildPerspectives",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Curriculum (Others)",
    "entityName": "isCurriculumOther",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining"
    ]
  },
  {
    "displayName": "Curriculum (STREAMin3)",
    "entityName": "isCurriculumStreamIn3",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining"
    ]
  },
  {
    "displayName": "Early Learning & Development Standards (ELDS)",
    "entityName": "isEarlyLearningDevelopmentSystem",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining"
    ]
  },
  {
    "displayName": "Early Literacy",
    "entityName": "isEarlyLiteracy",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining"
    ]
  },
  {
    "displayName": "Health and Safety",
    "entityName": "isHealthAndSafety",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining"
    ]
  },
  {
    "displayName": "CLASS Observation",
    "entityName": "isClassObservationTesting",
    "activities": [
      "itsCoaching",
      "itbcCoaching",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "LENA Coaching",
    "entityName": "isLenaCoaching",
    "activities": [
      "itsCoaching",
      "itbcCoaching"
    ]
  },
  {
    "displayName": "Pre/Post CLASS Environment",
    "entityName": "isPrePostClassEnvironment",
    "activities": [
      "itsCoaching",
      "itbcCoaching",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "QIP/CIP",
    "entityName": "isQipCip",
    "activities": [
      "itsCoaching",
      "itbcCoaching",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Toddler Teacher Sensitivity",
    "entityName": "isToddlerTeacherSensitivity",
    "activities": [
      "itsCoaching",
      "itsTraining",
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "ASQ-3 Screening",
    "entityName": "isAsq3",
    "activities": [
      "itbcCoaching",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "ASQ:SE-2 Screening",
    "entityName": "isAsqSe2",
    "activities": [
      "itbcCoaching",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Emotional Literacy",
    "entityName": "isEmotionalLiteracy",
    "activities": [
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Family Engagement",
    "entityName": "isFamilyEngagement",
    "activities": [
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "SE Development",
    "entityName": "isSeDevelopment",
    "activities": [
      "itbcCoaching",
      "itbcTraining",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Resources & Referrals",
    "entityName": "isResourcesAndReferrals",
    "activities": [
      "itbcCoaching",
      "itbcChildCoaching"
    ]
  },
  {
    "displayName": "Wellness and Retention",
    "entityName": "isWellnessAndRetention",
    "activities": [
      "itbcCoaching",
      "itbcTraining"
    ]
  },
  {
    "displayName": "ASQ-3/ASQ:SE-2",
    "entityName": "isAsqCombo",
    "activities": [
      "itbcTraining"
    ]
  },
  {
    "displayName": "Challenging Behaviors/Trauma",
    "entityName": "isChallengingBehavior",
    "activities": [
      "itbcTraining"
    ]
  },
  {
    "displayName": "Screening, Observation & Monitoring",
    "entityName": "isScreening",
    "activities": [
      "itbcTraining"
    ]
  },
  {
    "displayName": "Pre/Post Behavior Frequency Observation",
    "entityName": "isPrePostBehaviorFrequencyObservation",
    "activities": [
      "itbcChildCoaching"
    ]
  }
];

export function topicsForActivity(activity: TopicActivity): IEventDetailTopic[] {
    return EVENT_TOPIC_MATRIX.filter(topic => topic.activities.includes(activity)).map(topic => ({ ...topic })).sort((a, b) => a.displayName.localeCompare(b.displayName));
}
